<template>
  <div
    class="waggon-info-status t-rounded"
    :style="`
      width: ${width?width:''};
      border: ${selected && !no_border?`solid 1px ${status.name === 'stop'?'#F44336':'black'}`:''};
      ${bold?'font-weight: bold;':''}
      ${cursor?`cursor: ${cursor};`:''}
      `"
    >
    <AIIcon
      v-if="status.icon === 'ai_stop'"
      class="mr-1"
      width="16px"
      color="#F44336"
    />
    <v-icon
      v-else
      class="mr-1"
      small
      :color="status.name === 'stop' && selected?'#F44336':textcolor"
      >
      {{status.icon}}
    </v-icon>
    <div
      v-if="!no_text || selected"
      :style="`
        ${status.name === 'stop' && selected?'color: #F44336':''}
        ${$vuetify.breakpoint.smAndDown?'font-size: 8px;':''}
        `"
      >
      <!-- {{ }} -->
      <div v-if="status.name === 'stop'">
        {{status.name}}
      </div>
      <div v-else>
        {{$t(`Project.Workpackage.Status.${status.tooltip}`)}}
      </div>
    </div>
  </div>
</template>
<script>
  import AIIcon from '@/components/WorkBench/AIIcon.component.vue'
  export default {
    props: ['status', 'width', 'selected', 'bold', 'cursor', 'no_text', 'no_border', 'textcolor'],
    components: {
      AIIcon
    },
  }
</script>
<style>
  .waggon-info-status {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
  }
</style>
